const getDiffValues = (routePlan, journeyForUpgrade) => {
  if (!routePlan || !journeyForUpgrade) {
    return null;
  }

  const diffDistance = routePlan.distance - journeyForUpgrade.distance;
  const diffDistanceMiles = routePlan.distance_miles - journeyForUpgrade.distance_miles;
  const diffNetFullCost = routePlan.net_full_cost - journeyForUpgrade.net_full_cost;
  const diffNetFullPrice = routePlan.net_full_price - journeyForUpgrade.net_full_price;
  const diffNetMargin = routePlan.net_margin - journeyForUpgrade.net_margin;

  return {
    diffDistance,
    diffDistanceMiles,
    diffNetFullCost,
    diffNetFullPrice,
    diffNetMargin,
  };
};

const valueExists = (value) => typeof value !== 'undefined' && value !== null;

const PositiveSign = ({ value }) => (parseInt(value) > 0 ? <>+</> : null);

export { getDiffValues, valueExists, PositiveSign };
